import type { FaireProductEntity } from "../../entity_types/product";

export const p_fvkhtpndrq: FaireProductEntity = {
  token: "p_fvkhtpndrq",
  type: "product",
  name: "Woodfire Candle Co Flight Pack - Gift Set - Duluth Minnesota",
  brandName: "Woodfire Candle Company",
  imageUrl:
    "https://cdn.faire.com/fastly/69782a88e3e9ba0f1cabae8c504a477d63e2ad5a5b3cf2680d32560ee3388b49.jpeg",
  priceDollars: 19,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4eff0ce370003df5d1d80ee761fed350b005bc31852d761b7c5913d14e411f58.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
